<template>
    <h1>{{ data.value?.local?.title }}</h1>
    <div v-if="comments.length === 0">
        <div class="no_comments">{{data.value?.local?.empty}}</div>
    </div>

    <div v-else>

        <div id="comment_list">
            <div class="comment" v-for="(comment, index) in comments" :key="index">
                <div class="user">
                    <div class="avatar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#25282B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#25282B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="data">
                        <div class="name">{{comment.comment_author}}</div>
                        <div class="date">{{comment.formatted_date}}</div>
                    </div>
                </div>

                <div class="rating">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" v-for="n in 5" :key="n">
                        <g clip-path="url(#clip0_1082_6102)">
                            <path d="M8.54077 1.06637C8.71432 0.663389 9.28569 0.66339 9.45923 1.06637L11.316 5.37799C11.3884 5.54608 11.5468 5.66119 11.7291 5.67809L16.4034 6.11162C16.8403 6.15214 17.0169 6.69555 16.6872 6.98513L13.1604 10.0834C13.0229 10.2042 12.9624 10.3904 13.0027 10.569L14.0348 15.1485C14.1313 15.5765 13.669 15.9124 13.2917 15.6884L9.25528 13.2916C9.09792 13.1981 8.90208 13.1981 8.74472 13.2916L4.70825 15.6884C4.33099 15.9124 3.86874 15.5765 3.96521 15.1485L4.99735 10.569C5.03759 10.3904 4.97707 10.2042 4.83958 10.0834L1.31276 6.98512C0.98313 6.69555 1.15969 6.15214 1.59658 6.11162L6.27095 5.67809C6.45318 5.66119 6.61161 5.54608 6.684 5.37799L8.54077 1.06637Z"
                                  :fill="(n <= comment.rating ? '#F67B09' : '#E0E0E0')"/>
                        </g>
                        <defs>
                            <clipPath>
                                <rect width="18" height="18" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>

                </div>

                <div class="review">
                    <div v-if="shouldTruncate(comment.comment_content)">
                        <div v-if="!comment.expand">
                            {{ truncateContent(comment.comment_content) }}
                            <button class="readMoreButton" @click="toggleExpansion(comment)">
                                {{ comment.expand ? data.value?.local?.collapse : data.value?.local?.expand }}
                            </button>
                        </div>
                        <div v-else>
                            {{ comment.comment_content }}
                            <button class="readMoreButton" @click="toggleExpansion(comment)">
                                {{ data.value?.local?.collapse }}
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        {{ comment.comment_content }}
                    </div>
                </div>

            </div>
        </div>

        <button v-if="totalComments.approved > comments.length" @click="getComments" :class="{ loading: isLoadingList }" class="load_comments black">
            {{data.value?.local?.loadMore}}
            <div v-if="isLoadingList" class="loading_spinner"></div>
        </button>

    </div>
</template>

<script setup>

import {onMounted, reactive, ref} from "vue"
import {ajax} from "@/assets/js/Functions"
import '@/assets/css/reviews.css'

const data = reactive({})
const comments = ref([])
const itemsPerPage = ref(5)
const itemsOffset = ref(0)
const totalComments = ref(0)
const isLoadingList = ref(false)


const shouldTruncate = (content) => {
    // Здесь определите ваш порог ширины экрана для смартфонов
    const mobileScreenWidth = 768;
    return window.innerWidth < mobileScreenWidth && content.length > 200 ||
        window.innerWidth >= mobileScreenWidth && content.length > 400;
};

const truncateContent = (content) => {
    const maxLength = window.innerWidth < 768 ? 200 : 400;
    return `${content.slice(0, maxLength)}...`;
};

const toggleExpansion = (comment) => {
    comment.expand = !comment.expand;
}

const getStarFill = (index, rating) => {
    return index <= this.rating ? '#F67B09' : '#E0E0E0'
}

onMounted(async () => getComments());

function getComments()
{
    isLoadingList.value = true
    ajax({
        action: "get_comment_list",
        offset: itemsOffset.value
    }, (response) => {
        console.log(response)
        itemsOffset.value += itemsPerPage.value
        data.value = response
        comments.value = [...comments.value, ...response.comments]
        totalComments.value = response.count
        isLoadingList.value = false
    });
}

</script>

<style scoped>
.readMoreButton{
    color: #007EFF;
    font-size: 14px;
    font-weight: 500;
    border: none;
    padding: 0;
    display: block;
    margin: 20px 0 0;
}
</style>